import { Auth } from '@aws-amplify/auth'
import getFQDN from './rest'
import LOG from '../logging/Logger'
import { isProduction, isStaging } from './util/environment'

export async function getIncomingEmail() {
  const currentUser = await Auth.currentAuthenticatedUser()
  return currentUser.attributes['custom:incomingEmail']
}

export async function createIncomingEmail() {
  const currentUser = await Auth.currentAuthenticatedUser()
  const createEmailResult = await fetch(getFQDN('v1/create-incoming-email'), {
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      username: currentUser.username,
      email: currentUser.attributes['custom:incomingEmail']
    })
  })
  const incomingEmail = await createEmailResult.json()

  if (incomingEmail) {
    if (incomingEmail.error) {
      LOG.error('incomingEmail error:', incomingEmail.error)
      return
    }
    LOG.info('incomingEmail:', incomingEmail)
    const newGuid = incomingEmail.newGuid
    Auth.updateUserAttributes(currentUser, {
      'custom:incomingEmail': newGuid
    })
    return newGuid
  }
}

export function getIncomingEmailSuffix() {
  if (isProduction()) {
    return '@tasks.gettingfocused.com'
  } else if (isStaging()) {
    return '@tasks-staging.gettingfocused.com'
  } else {
    return '@tasks-dev.gettingfocused.com'
  }
}
